var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-button-create",on:{"click":_vm.create}},[_vm._v("\n  ユーザーの作成\n")])}
var staticRenderFns = []

export { render, staticRenderFns }